// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ndiv.title[data-v-60ea52c0] { font-size: 16px; color: var(--main-gray-5); border-bottom: 1px solid var(--main-gray-3); width: 100%; padding-bottom: 10px; margin: 5px 0 5px 0;\n}\n*[data-v-60ea52c0] .w-checkbox-label { color: var(--main-gray-6);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
